// Module
var code = "<div> <div view=\"[[ top.view ]]\" data=\"[[ top.data ]]\"></div> </div> ";
// Exports
export default code;